export class GeocodeService {
    countryCode = ''
    urlAPP =
        'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/'

    constructor(countryCodeInput) {
        if (!countryCodeInput) {
            this.countryCode =
                'FRA, BEL, DEU, ITA, LUX, REU, ESP, CHE, GUF, MCO, PYF, BLM, MTQ, GLP, NCL, PRT, NLD'
            return
        }

        this.countryCode = countryCodeInput
    }

    async RechercheAdresse(recherche) {
        const requestOptions = {
            method: 'GET'
        }

        const parametres = {
            text: recherche,
            maxSuggestions: 5,
            countryCode: this.countryCode,
            f: 'json'
        }

        var response = await fetch(
            this.urlAPP +
                'suggest' +
                '/?' +
                new URLSearchParams(parametres).toString(),
            requestOptions
        )
        var returnValue = await response.json()

        return returnValue
    }

    async RechercheKey(key) {
        const requestOptions = {
            method: 'GET'
        }

        const parametres = {
            outFields: '*',
            magicKey: key,
            f: 'json'
        }

        var response = await fetch(
            this.urlAPP +
                'findAddressCandidates' +
                '/?' +
                new URLSearchParams(parametres).toString(),
            requestOptions
        )
        var returnValue = await response.json()

        return returnValue
    }
}
